













































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import BuySellFXDialog from '@/components/Accounts/DepositAccounts/Wallets/BuySellFX/BuySellFXDialog.vue';
import WalletsTransferDialog from '@/components/Accounts/DepositAccounts/Wallets/Transactions/WalletsTransferDialog.vue';
import WalletsCreateDialog from '@/components/Accounts/DepositAccounts/Wallets/WalletsCreateDialog.vue';
import WalletSubTabs from '@/components/Accounts/DepositAccounts/Wallets/WalletSubTabs.vue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import PermissionType from '@/models/Settings/Roles/PermissionType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'WalletSelectorToolbar', components: { BuySellFXDialog, WalletsTransferDialog, WalletsCreateDialog, WalletSubTabs } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    selectedWalletID: string = "";

    @Prop({required: true})
    account: DepositAccountSummary;

    async beforeMount() {
        const defaultWallet = this.account.wallets.find(wallet => wallet.default);
        this.selectedWalletID = defaultWallet.id;
    }

    @Watch('selectedWalletID')
    async onSelectedWalletChanged(val: boolean) {
        //await DepositAccountModule.getWalletDetails(this.selectedWalletID);
        // TODO: Remove getWalletInterestAccrual once the getWalletDetails has been updated to return interest accrual
        await DepositAccountModule.getWalletInterestAccrual(this.selectedWalletID);
        await DepositAccountModule.getWalletTransactions({id: this.selectedWalletID, page: 1});
        await DepositAccountModule.getWalletPendingTransactions({id: this.selectedWalletID, page: 1});
    }

    get selectedWallet() {
        return DepositAccountModule.currentDepositAccountWallet;
    }

    get hasOnlyOneWallet() {
        return this.account.wallets.length === 1;
    }

    get isSecondaryWalletsEnabled() {
        // Check both the account settings for secondary wallets being present, and the permission for customer accounts manage
        return this.account.accountSettings.secondaryWalletSettings && PermissionUtils.hasPermission(PermissionType.DepositAccountsManage);
    }

}
